import { SubMenuItem } from './subMenuItem';

export interface MenuItem {
  name?: string;
  pages?: SubMenuItem[];
  code?: string;
}
